import { MutationTree } from "vuex";
import { NewslettersState } from "./types";

export const mutations: MutationTree<NewslettersState> = {
    newsletters(state, payload: any[]) {
        state.newsletters = payload;
    },
};
